<template>
    <div id="appManager" :data-processing="processing">

        <LoginForm :appState="appState" :siloData="data" @refreshData="refreshData" @updateState="updateState" @updateSiloOnLogin="$emit('updateSiloOnLogin')"/>

        <!-- not using currently -->
        <UserSorter :appState="appState" :siloData="data" @updateState="updateState" />

        <!-- maybe make this part of the login form, or put them together? -->
        <Card :appState="appState" :siloData="data" activator="terms" :hideClose="true" v-bind:hasChildren="false"
                    @updateState="updateState" @processing="setProcessing" @refreshData="refreshData" />

        <!--
        in the future i should have two loops outside the ready to use and inside
        they look through two arrays of page data inside the theme admin
        each loop outputs a card which has props for title, opener, etc etc
        this will make page creation much faster
        -->


        <div v-if="canActivateHomeScreen">
            <Events :siloData="data" />
            <ActiveChecker />
            <IntroFlow :appState="appState" :siloData="data" />
            <TopicMenuSP :appState="appState" :siloData="data" :processing="processing" activator="topic"
                @updateState="updateState" @processing="setProcessing" @refreshData="refreshData" />
            <Card :appState="appState" :siloData="data" activator="goals" v-bind:hasChildren="false"
                    @updateState="updateState" @processing="setProcessing" @refreshData="refreshData" />
            <Card :appState="appState" :siloData="data" activator="checkin" v-bind:hasChildren="false"
                    @updateState="updateState" @processing="setProcessing" @refreshData="refreshData" />
            <ModuleLoaderSP :appState="appState" :siloData="data" @updateState="updateState" @processing="setProcessing"
                @refreshData="refreshData" @moduleComplete="moduleComplete" />
            <VideoPlayer :appState="appState" :siloData="data" />
            <HomeScreenSP :appState="appState" :siloData="data" :readyToUse="canActivateHomeScreen" @refreshData="refreshData" @updateState="updateState" @setNav="setNav" @logout="$emit('logout')" />
        </div>

    </div>
</template>

<script>
import Events from '@c/Events.vue'
import HomeScreenSP from '@c/HomeScreenSP.vue'
import ModuleLoaderSP from '@c/ModuleLoaderSP.vue'
import Card from '@c/Card.vue'
import VideoPlayer from '@c/VideoPlayer.vue'
import ActiveChecker from '@c/ActiveChecker.vue'
import LoginForm from '@c/LoginForm.vue'
import TopicMenuSP from '@c/TopicMenuSP.vue'
import IntroFlow from '@c/IntroFlow.vue'
import UserSorter from '@c/UserSorter.vue'
import { jwtDecode } from 'jwt-decode'

const axios = require('axios');

export default {
    components: {
        Events,
        HomeScreenSP,
        ModuleLoaderSP,
        Card,
        VideoPlayer,
        ActiveChecker,
        LoginForm,
        TopicMenuSP,
        IntroFlow,
        UserSorter,
    },
    data() {
        return {
            appState: 'login',
            navOpen: false,
            processing: false,
            data: this.siloData,
            showModuleActive: false,
            canActivateHomeScreen: false,
            count: 0,
            interval_id: null,
            pulse_rate: 10, // how often we push up a time amount to the database
        }
    },
    computed: {
        // THIS NEVER HAPPENS TO A NEW USER BECAUSE THE SILO DATA DOESNT CHANGE FOR THIS OBJECT UNTIL SECOND LOG IN
        startTheClock() {
            let returned = false;

            // Make sure the user has completed the login flow
            if (this.canActivateHomeScreen) {
                returned = true;
            }

            return returned;
        },
    },
    async created() {
        //await this.checkLoginState();
        const loggedIn = await this.checkLoginState();

        if (loggedIn) {
            console.log('we are logged in on created check if ready to use');
            this.readyToUse();
            this.startTimer();
        } else {
            console.log('we are not logged in on created, do nothing');
        }
    },
    mounted() {
        window.appManager = this;
        console.log('mounted');
        //this.readyToUse();
        //this.verifyLoggedIn();
        // Start the clock
        //this.startTimer();
    },
    props: {
        siloData: Object
    },
    watch: {
        // ??? DOES THIS NEVER FIRE ???
        async siloData() {
            console.log('app manager: silo data has changed');
            // This needs to be sequential I think
            await this.refreshData();
            this.$nextTick(() => {
                console.log('app manager: watch: finished updating silo data, checking if ready to use');
                this.readyToUse();
            });
        }
    },
    methods: {
        readyToUse(tou_override = false) {
            console.log('app manager: readytouse: checking if ready to use');

            console.log('app manager: access token', localStorage.getItem('access_token'));
            if (localStorage.getItem('access_token') === null) {
                console.log('app manager: no access token, not ready to use');
                return false;
            }

            // If there is no silo data stop
            if (this.siloData === null || this.siloData.user.id === 0) {
                console.log('app manager: ready to use: no silo data, stop');
                if (this.appState !== 'login') {
                    this.appState = 'login';
                }
                return false;
            }

            if (tou_override === false) {
                // If they haven't signed ToU stop and make them
                if (this.siloData.user.stats.has_signed_tou === null || this.siloData.user.stats.has_signed_tou === "false") {
                    console.log('app manager: ready to use: hasnt signed terms, stop', this.siloData.user.stats.has_signed_tou);
                    //this.appState = 'terms';
                    if (this.appState !== 'sort') {
                        this.appState = 'sort';
                    }
                    return false;
                }
            }

            console.log('app manager: all checks passed, ready to use home app/homescreen');
            this.canActivateHomeScreen = true;
            return true;
        },
       async checkLoginState() {
            console.log('^^^ appmanager: checking login state');
            const token = localStorage.getItem('access_token');

            // 1️⃣ No token at all
            /*
            if (!token) {
                console.log('^^^ appmanager: no access token, login again');
                this.softLogoutUser();
                return false;
            }
            */
               // No access token — but maybe we can recover with a refresh token
                if (!token) {
                    const refresh = localStorage.getItem('refresh_token');
                    if (!refresh) {
                        console.log('^^^ appmanager: no access or refresh token, login again');
                        this.softLogoutUser();
                        return false;
                    }
                    try {
                        await this.refreshToken();
                        this.appState = 'home';
                        return true;
                    } catch (err) {
                        console.warn('Refresh failed on missing access token:', err);
                        this.softLogoutUser();
                        return false;
                    }
                }

            console.log('^^^ appmanager: access token found, checking validity');

            try {
                const decoded = jwtDecode(token);
                const now = Math.floor(Date.now() / 1000);

                console.log('^^^ appmanager: decoding token', decoded);

                // 2️⃣ Token expired → try refresh
                if (decoded.exp && decoded.exp < now) {
                    await this.refreshToken();
                }

                console.log('^^^ appmanager: u r good');

                // 3️⃣ Token valid or refreshed
                this.appState = 'home';
                return true;
            } catch (err) {
                console.warn('Auth check failed:', err);
                this.softLogoutUser();
                return false;
            }
        },
        // ! DO I DO THIS TWICE ALREADY? (Once in app.js)
        async refreshToken() {
            const refresh = localStorage.getItem('refresh_token');
            if (!refresh) throw new Error('No refresh token');

            try {
                const res = await axios.post('/wp-json/jwt-auth/v1/token/refresh', {
                    refresh_token: refresh
                });

                localStorage.setItem('access_token', res.data.token);
                localStorage.setItem('user', JSON.stringify({
                    id: res.data.user_id,
                    roles: res.data.roles,
                    meta: res.data.meta
                }));
            } catch (err) {
                if (err.response?.status === 403) {
                    console.log('refresh token failed, return to login');
                    // refresh token itself is invalid/expired
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                    localStorage.removeItem('user');
                }
                throw err; // re-throw so checkLoginState still catches it and sets appState = 'login'
            }
        },

        // Check to make sure you are logged in and adjust the state if we aren't
        verifyLoggedIn() {
            console.log('verifyLoggedIn');
            // If we're logged in, just ignore this
            // NOTE: Have to do this with the tokens
            //if (localStorage.getItem('access_token') == null && localStorage.getItem('refresh_token') == null) { this.appState = 'login'; }

            if (this.siloData.user.id !== 0) {
                console.log('Verify passed, user is logged in');
                if (this.siloData.user.stats.meta_us_has_signed_tou === null || this.siloData.user.stats.meta_us_has_signed_tou === "false") {
                    console.log('user hasnt signed terms, forward to terms');
                    // this.appState = 'terms';
                    this.appState = 'sort';
                } else {
                    console.log('user has signed terms, forward to home');
                    this.appState = 'home';
                }
            } else {
                console.log('Verify failed, show login');
                this.appState = 'login';
            }
        },
        // Redirect to the login flow
        redirectToStart() {
            console.log('redirecting to start');
            window.location.href = this.siloData.urls.start;
        },
        updateState(newState) {
            console.log('app manager, updateState: updating state', newState);
            this.appState = newState;

            // ! Move this to HomeScreen
            if (newState === 'home') {
                //window.animator.show_home();
            } else {
                //window.animator.hide_home();
            }
        },
        setNav(navSetting) {
            this.navOpen = navSetting;
        },
        setProcessing(state) {
            this.processing = state;
        },
        async refreshData(onComplete = null) {

            console.log('AM: refreshing data');

            // TODO: Come back to this later
            if (this.siloData.urls === null) { return; }

            // ! This may be insecure
            const id = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : this.siloData.user.id;

            //console.log('refreshing data');
            this.setProcessing(true);

            try {
                console.log('AM: pulling data');
                //const response = await axios(this.siloData.urls.getsilodata + '&id=' + id);
                const response = await axios(this.siloData.urls.getsilodata);
                //this.data = response.data;
                this.data = { ...response.data }

                let parsed = JSON.parse(JSON.stringify(this.data));

                if (parsed.user.id === 0) {
                    console.log('USER IS NOT LOGGED IN');
                    this.softLogoutUser();
                }

                // So what happens here is that the data we receive is not the same as the data
                // this component gets when we save it as this.data
                // however, the child components all get the correct data
                // I parse it here so that we can override the readytouse script with
                // the correct updated data and force the user to the homepage
                if (this.canActivateHomeScreen === false) {
                    let tou = parsed.user.stats.has_signed_tou;
                    if (tou === 'true') {
                        this.readyToUse(true);
                    }
                }

                // TODO: Run check to make sure we're logged in or not


            } catch (err) {
                console.log('something went wrong', err);
            } finally {

                this.setProcessing(false);

                console.log('AM: doing finally');

                if (onComplete !== null) {
                    this.$nextTick(() => {
                        console.log('app manager firing onComplete callback');
                        // ! MAYBE ADD A PAUSE HERE?
                        onComplete;
                    });
                }

                if (this.canActivateHomeScreen === false) {
                    console.log('AM: checking ready to use at the end of refresh data');
                    this.$nextTick(() => {
                        this.readyToUse();
                    });
                }

            }

        },
        // Fires when a module is completed
        moduleComplete() {
            this.showModuleActive = true;
        },
        moduleCompleteReset() {
            this.showModuleActive = false;
        },
        // Creates a new timer
        startTimer() {
            // Check to make sure the active checker is avaialble, if it isn't just restart
            if (this.startTheClock!==true) {
                //console.log('active checker not found, restarting');
                setTimeout(() => {
                        this.startTimer();
                    }, 1000);
            } else {
                //console.log('timer started!');
                // Store the interval ID so it can be cleared later
                this.intervalId = setInterval(() => {
                    // If we're active, add a second, otherwise don't
                    if (window.activeChecker.active === true && this.data.user.id !== 0) {
                        this.count++;
                        // Once the timer reaches our desired incriment
                        // Rese the timer
                        if (this.count == this.pulse_rate) {
                            this.resetTimer();
                        }
                    } else {
                        //console.log('you are inactive, not adding to app timer');
                    }
                }, 1000);
            }
        },
        // Resets the current timer and pushes it up to the database
        resetTimer() {
            //console.log('time spent on app increased: ', this.count);

            // Pass the current count to the server
            this.postTime(this.count);

            // Reset count
            this.count = 0;
        },
        postTime(time) {
            let data = {
                id: this.siloData.user.id,
                key: `meta_us_total_time`,
                value: time,
            }
            //console.log(data);
            axios.post(this.siloData.urls.posttime, data).then(result => {
                let now = new Date();
                //console.log('APP TIMER POSTED', now.toISOString());
                //console.log(result);

                // UNCOMMENT THIS IF IT CAUSES ISSUES
                //this.$emit('refreshData');
            });
        },
        // This is what happend when the user gets logged out on the backend while they are using the front end
        softLogoutUser() {
            this.appState = 'login';
            this.$emit('logoutSoft');
        },
    },
}
</script>

<style lang="scss">
#appManager {
    //padding-top: env(safe-area-inset-top);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>